import { render, staticRenderFns } from "./copy_to_clipboard.vue?vue&type=template&id=0b19c4ea&"
import script from "./copy_to_clipboard.vue?vue&type=script&lang=js&"
export * from "./copy_to_clipboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports